const en = {
  others: {
    generalStatistics: 'General Statistics',
    wpp: 'Wind power plants (WPP)',
    spp: 'Solar power plants (SPP)',
    allWpp: 'All WPP',
    allSpp: 'All SPP',
    WppSpp: 'WPP-SPP',
    spp_nikopol: 'Nikopolska SPP',
    spp_pokrovsk: 'Pokrovska SPP',
    spp_trifanovsk: 'Trifanovska SPP',
    wpp_tiligul: 'Tiligulska WPP',
    windPowerPlants: 'Wind power plants (WPP)',
    solarPowerPlants: 'Solar power plants (SPP) ',
    dashboard: 'Dashboard',
    unbalance: 'Unbalance',
    powerBI: 'Power BI',
    forecasts: 'Forecasts',
    map: 'Map',
    businessPlan: 'Business plan',
    users: 'Users',
    restrictionsJournal: 'Restrictions Journal',
    restrictionsJournalCreate: 'Creation application',
    restrictionsJournalView: 'View application',
    restrictionsJournalEdit: 'Editing an application',
    forecastAndActualProduction: 'Forecast and actual production (WPP, SPP)',
    deviation: 'Deviation',
    totalVariation: 'Total variation',
    keyMetrics: 'Key Metrics',
    liveData: 'Live data',
    budgetVsFact: 'Budget vs fact',
    generalUnbalanceTooltip: 'Positive and negative unbalances, also their sum',
    unbalanceOutOfRangeTooltip:
      'Positive and negative unbalances that go beyond the permissible threshold, also their sum',
    percentageOfPredictionsTooltip:
      'Percentage of predictions that came true within the acceptable deviation threshold ',
    biasTooltip: 'Discrepancies between the forecast data and the actual (factual) data ',
    nmaeTooltip: 'Normalized mean absolute error',
    nrmseTooltip: 'Normalized mean square error',
    energyAvailabilityTooltip:
      'The energy availability coefficient is calculated for full calendar months, regardless of the days selected in the filter',
    bpNameAndDescriptionChanges: 'BP name and description of recent changes',
    bpDate: 'Upload date and time',
    bpAuthor: 'Author',
    bpTemplate: 'Business plan template',
    currentCapacity: 'Current capacity',
    projectCapacity: 'Project capacity',
    nestedListItems: 'Nested List Items',
    variationOfForecast: 'Variation of forecast from actual production',
    forecast: 'Forecast',
    actual: 'Actual',
    station: 'Station',
    namePlan: 'Business plan of generation WPP-SPP',
    descriptionRecentChanges: 'Uploaded:',
    Production: 'Production',
    EnergyAvailability: 'Energy Availability',
    WindResource: 'Wind Resource',
    Insolation: 'Insolation',
    forecastHorizon: 'Forecast horizon',
    Average: 'Average',
    'Guaranteed Buyer': 'Guaranteed Buyer',
    Model: 'Model',
    Fact: 'Fact',
    startDateRDC: '',
    powerCommandRestriction: '',
    powerBefore: '',
    endDateRDC: '',
    duration: '',
    powerAfter: '',
    lossesSCADA: '',
    lossesCalculatedOrEtalon: '',
    positiveImbalance: 'Positive imbalance',
    negativeImbalance: 'Negative imbalance',
    relativeUnbalanceIndex: 'Relative unbalance index',
    OperationalJournal: 'Operational Journal',
    OperationalJournalCreate: 'Create a record',
    OperationalJournalView: 'View entry',
    OperationalJournalEdit: 'Edit entry',
    OperationalJournalCreateRecord: 'Create an independent record',
    OperationalJournalShiftTransfer: 'Shift Transfer',
    OperationalJournalShiftAcceptance: 'Shift Acceptance',
    OperationalJournalShiftsHistoryDetails: 'View Shift Transfer History',
    Administration: 'Administration',
    AdministrationCreate: 'Add new user',
    AdministrationEdit: 'Editing user data',
    AdministrationView: 'View user data',
    peopleId: 'User ID',
    email: 'Email',
    name: 'Name',
    surname: 'Surname',
    role: 'Role',
    location: 'Location',
    admin: 'Admin',
    stationShiftSupervisor: 'Station Shift Supervisor',
    user: 'User',
    analyst: 'Analyst',
    stationAnalyst: 'Station Analyst',
    stationDirector: 'Station Director',
    searchPlaceholder: 'Search...',
    noData: 'No data to display',
  },
  infoMessages: {
    selectedPeriodNotMultipleCalendarWeek:
      'You have selected a period that is not a multiple to a calendar week. Indicators NMAE, NMRSE and bias will be displayed incorrectly',
    loadingPleaseWait: 'Loading, please wait',
    notAccess: 'This page does not match the access rights',
    connectSupport:
      'Contact<supportLink>{{supportService}}</supportLink> for access control and data display',
    supportService: 'support service',
    supportEmail: 'support@dtek.com',
    supportEmailSubject: 'Access rights to WatchTower control system',
    dataLoadingError: 'Data loading error',
    errorLoadingFile: 'Error loading file',
    errorLoadingDateEmptyData: 'Error loading dates for which data is present',
    errorLoadingListForecasters: 'Error loading the list of forecasters',
    bPSuccess: 'Business plan uploaded successfully',
    updatingData: 'Updating data',
    fileError: 'File error',
    fileWarningDuplicate: 'Data duplication in the file',
    uploadBpFileValidationError:
      'The file being updated does not meet the template requirements. There is an error in the cell: {{invalidCellAddress}}',
    uploadBpFileParseError: 'Business plan file processing error: {{parseErrorMessage}}',
    uploadBpFileRowsValidationError:
      'File structure error: Invalid file structure or number of lines. There should be missing data after line 177',
    uploadBpFileReadError: 'Error reading file. Please check the file format',
    uploadBpFileRequiredCellsMessage:
      'Before uploading the file, make sure that all required fields are filled in.',
    uploadedBpFileDuplicateMessage:
      'The uploaded business plan parameters completely match the previous one.',
    generalImbalance: 'General imbalance',
    totalDeviation: 'Total deviation',
    title404: 'The page you are looking for does not exist or has been deleted',
    desc404_1: 'Try to start your journey with',
    desc404_2: 'home page',
    dataUpdateSuccess: 'Changes added successfully',
    deleteData: 'Entry deleted successfully',
    dataUpdateError: 'Changes not added. Please contact support for assistance',
    dataCreateSuccess: 'Entry created successfully',
    dataCreateError: 'Error creating entry. Please contact support for assistance',
    shiftTransferError: 'Error loading shift. Please contact support for assistance',
    sendShiftTransferSuccess: 'Shift transferred successfully',
    sendShiftTransferError: 'Error transferring shift. Please contact support for assistance',
    shiftAcceptanceError:
      'Error loading shift acceptance data. Please contact support for assistance',
    acceptShiftSuccess: 'Shift accepted successfully',
    acceptShiftError: 'Error accepting shift. Please contact support for assistance',
    equipmentCreateError: 'Error creating equipment. Please contact support for assistance',
    equipmentCreateSuccess: 'Equipment created successfully',
    editRequestSendSuccess: 'Edit record request has been sent',
    editRequestSendConflict: 'Edit record request has already been sent',
    editRequestAcceptSuccess: 'Edit record request has been approved',
    editRequestRejectWarning: 'Permission to edit the record is not granted',
    internalErrorTitle: 'Something went wrong...',
    internalErrorSubtitle:
      'Data could not be loaded. Try refreshing the page or checking your internet connection.',
  },
  btn: {
    ok: 'Ok',
    save: 'Save',
    cancel: 'Cancel',
    continue: 'Continue',
    downloadTemplate: 'Download template',
    updateBP: 'Update BP',
    downloadBP: 'Download current BP indicators',
    delete: 'Delete',
    edit: 'Edit',
    not: 'Not',
    yes: 'Yes',
    send: 'Send',
    understood: 'Understood',
    update: 'Update',
  },
  unit: {
    mw: 'MW',
    kWh: 'kWh',
    wm2: 'W/m²',
    mc: 'm/s',
    mWH: 'MW•H',
    kilowatt: 'kW',
    kilowattMeter2: 'kW/m²',
    percentageFell: 'Percentage of predictions that fell within acceptable limits',
    hour: 'hour',
    hours: 'hours',
  },
  date: {
    today: 'Today',
    lastWeek: 'Last week',
    currentWeek: 'This week',
    prevWeek: 'Previous week',
    currentMonth: 'Current month',
    PrevMonth: 'Previous month',
    lastYear: 'Last year',
    currentYear: 'Current year',
    from: 'From',
    to: 'To',
    titleDRP: 'Select a period',
    hour: 'hour',
    hours: 'hours',
    calendar: 'Calendar',
    year: 'Year',
    weekToDate: 'Week to date',
    monthToDate: 'Month to date',
    yearToDate: 'Year to date',
  },
  powerBI: {
    bp_imbalances: 'BP / Imbalances',
    reports: 'Drill-down reports',
    openPowerBI: 'Open PowerBI in a new tab',
  },
  operationalJournal: {
    currentShift: 'Current shift - {{shiftName}}',
    dateLastChange: 'Date of last change: {{lastUpdatedAt}}',
    applyFilter: 'Apply filter',
    filtering: 'Filtering',
    clear: 'Clear',
    recordsPerPage: 'Journal records per page',
    record: 'Record',
    createRecord: 'Create record',
    transferShift: 'Transfer shift',
    acceptShift: 'Accept shift',
    operationalLabel: 'Operational record',
    commentLabel: 'Comment',
    plantLabel: 'Plant',
    addEquipmentPlaceholder: 'Add equipment',
    createEquipment: 'Create equipment',
    equipment: 'Equipment',
    voltageClasses: 'Voltage classes, kV',
    electricalSystems: 'Electrical systems',
    equipmentTypes: 'Equipment types',
    electricalConnections: 'Electrical connections',
    dispatchNames: 'Dispatcher names',
    fullName: 'Full name',
    recordType: 'Record Type',
    eventTimeAndDate: 'Event date and time',
    familiarization: 'Familiarization',
    equipmentObjects: 'Objects',
    equipmentObject: 'Object',
    describeEvent: 'Event description',
    deviation: 'Deviation from normal operation scheme',
    noDataSubtitle: 'No entries have been added to the operational journal yet',
    noFilterResults: 'No results match the filter criteria.',
    noFilterResultsSubtitle: 'Select different parameters to filter the records',
    noShiftsHistorySubtitle: 'No accepted shifts',
    shiftsHistoryDetailTitle: 'Shift Transfer Details',
    logDateAccepting: 'Acceptance date and time',
    logDateTransfer: 'Transfer date and time',
    acceptanceDateFilter: 'Acceptance date',
    transferDateFilter: 'Transfer date',
    fromDate: 'Start date',
    toDate: 'End date',
    eventDate: 'Event date',
    eventTime: 'Event time',
    earthing: {
      label: 'Earthing',
      InstallingPortable: 'Installing portable earthing',
      RemovingPortable: 'Removing portable earthing',
    },
    limitation: {
      label: 'Limitation',
      Introduction: 'Entering a restriction',
      Removal: 'Removing a restriction',
    },
    tabs: {
      logs: 'Record list',
      shiftsHistory: 'Shift transfer history',
      details: 'Detailed information',
      history: 'Record change history',
    },
    history: {
      updatedAt: 'Date and time of change',
      action: 'Performed actions',
      oldValue: 'Previous value',
      newValue: 'New value',
      signer: 'Editor',
      noData: 'No change history data',
    },
    dialogs: {
      unsavedChanges: {
        title: 'Warning about data loss',
        subtitle: 'You are about to change the record type',
        description: 'All unsaved changes will be lost. Are you sure you want to continue?',
      },
      cancelSaveRecord: {
        title: 'Warning about data loss',
        subtitle: 'You are about to cancel saving the record',
        description: 'If you cancel saving, all entered data will be lost',
      },
      createEquipment: {
        title: 'Create Equipment',
      },
      cancelCreateEquipment: {
        title: 'Warning about data loss',
        subtitle: 'You are about to cancel creating the equipment',
        description: 'If you cancel creating, all entered data will be lost',
      },
      existEquipment: {
        title: 'Equipment already exists',
        subtitle:
          'It is not possible to save this equipment because a record with the same combination of fields already exists in the system.',
        description: 'Please change the value of one or more fields to create unique equipment',
      },
      confirmSaveChanges: {
        title: 'You are about to save the record',
        subtitle: 'Make sure the selected equipment list is up to date.',
        description:
          'After saving the record, it will not be possible to change the content of the "Equipment" field',
      },
      confirmSendEditRequest: {
        title: 'Editing record is not available',
        subtitle: '24 hours have passed since the record was created',
        description:
          'To make changes to the record, send a request to the authorized person for editing',
      },
    },
    deviationNotification:
      'Changing the "Deviation from normal operation scheme" flag will affect the obligation to transfer the event by shift',

    operationalUnavailable: 'Operational record unavailable',
    operationalUnavailableDescription: 'Accept the shift to create an operational record',
    editRequestApproval: {
      pendingBannerText: '{{name}} sent you a request to edit the operational journal record',
      approveButton: 'Approve',
      rejectButton: 'Reject',
      alreadyProcessedTitle: 'Request already processed',
      approvedByOther: 'The request to edit this record has been approved',
      rejectedByOther: 'The request to edit this record has been rejected',
      approvedByMe: 'The request to edit this record has been approved by you',
      rejectedByMe: 'The request to edit this record has been rejected by you',
      authorizedPerson: 'Authorized person: {{name}}',
      permissionGranted: 'Permission to edit the record has been granted',
      permissionDenied: 'Permission to edit the record has not been granted',
    },
  },
  shiftTransfer: {
    title: 'You are starting the shift transfer',
    description:
      'Please make sure that the list of events with the "Deviation from normal operation scheme" flag is up to date. If necessary, update the status of this flag.',
    recipientEmployeeLabel: 'Full name of the employee to whom the shift is transferred',
    permitToWorkLabel: 'Permit to Work',
    switchingOrderLabel: 'Switching Order',
    deviationEventsLabel: 'Events of deviations from the normal mode scheme',
    otherEventsLabel: 'Other events',
    transferShiftButton: 'Transfer shift',
    noAddedEvents: 'No events added',
    noAddedEventsInCurrentTime:
      'At the moment when the shift was handed over, no events were added',
    dialogs: {
      cancelSaveRecord: {
        title: 'Warning about data loss',
        subtitle: 'You are about to cancel the shift transfer',
        description: 'If the process is canceled, all entered data will be lost',
      },
      returnToNormalOperation: {
        title: 'Return to normal operation scheme',
        subtitle:
          'The "Deviation from normal operation scheme" flag will be removed from this record',
        description: 'After confirmation, the record will be moved to the "Other events" category',
      },
      deviationsFromNormalOperation: {
        title: 'Deviation from normal operation scheme',
        subtitle:
          'This record will be marked with the "Deviation from normal operation scheme" flag',
        description:
          'After confirmation, the record will be moved to the category "Events related to deviation from the normal operation scheme"',
      },
      deviationConflict: {
        title: 'Data Updated',
        subtitle:
          'The list of events related to deviations from the normal operation scheme has been changed as a result of actions by another user',
        description: 'Refresh the page to display the most up-to-date information',
      },
    },
  },
  shiftAcceptance: {
    warningText:
      'Before accepting the shift, please review all events and mark those you have familiarized yourself with. After accepting the shift, responsibility for these events will be transferred to you.',
    title: 'You are starting the shift acceptance',
    senderLabel: 'Transfer the shift',
    permitToWorkLabel: 'Permit to Work',
    switchingOrderLabel: 'Switching Order',
    deviationEventsLabel: 'Events of deviations from the normal mode scheme',
    otherEventsLabel: 'Other events',
    acceptShiftButton: 'Accept shift',
    noAddedEvents: 'No events added',
    eventsToFamiliarize:
      'Familiarize yourself with and confirm the events before accepting the shift',
    acceptShiftTooltip:
      'The button is activated only after consciously confirming the review of all events',
  },
  validations: {
    required: 'Required field',
    maxLength4: 'Maximum length is 4 characters',
    maxLength500: 'Maximum length is 500 characters',
    atLeastOneEquipment: 'At least one equipment must be added',
    invalidDate: 'Invalid date',
    invalidTime: 'Invalid time',
  },
  routerConfirmationDialog: {
    title: 'Warning about data loss',
    youAreGoingToLeave: 'You are about to leave the page',
    changesWillBeLost: 'If you leave the page, all entered data will be lost',
  },
}

export default en
